import { Card } from '@/common/ui/Card'
import { Button } from '@/common/ui/Form/Button'
import { Link } from 'react-router-dom'
import { Icon } from '@/common/ui/Icon/Icon'

export const LegalPage = () => {
    return (
        <>
            <div className='profile-content'>
                <h2 className='font-medium text-[20px]/[22px]'>Юридическая информация</h2>
            </div>
            <Card className='profile-content'>
                <div>
                    <Button emphasis='accent' variant='ghost' className='text-left leading-none'>
                        <Link to='/eula.pdf' target='_blank'>
                            Публичная оферта
                            <Icon name='send-square' className='w-4 h-4 inline-block ml-2' />
                        </Link>
                    </Button>
                    <br />
                    <Button emphasis='accent' variant='ghost' className='text-left leading-none'>
                        <Link to='/privacy.pdf' target='_blank'>
                            Политика в отношении обработки персональных данных
                            <Icon name='send-square' className='w-4 h-4 inline-block ml-2' />
                        </Link>
                    </Button>
                </div>
            </Card>
        </>
    )
}
